module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": ""
    }
  }, [_c('bdialog', {
    attrs: {
      "config": _vm.bconfig
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userType == 0),
      expression: "userType == 0"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addVer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addver')))]), _vm._v(" "), _c('div', _vm._l((_vm.tableData), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "box-card gTopMg vcard"
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticClass: "vcardtt",
      staticStyle: {
        "line-height": "36px"
      }
    }, [_vm._v(_vm._s(item.version))]), _vm._v(" "), _c('span', {
      staticClass: "vcardtt",
      staticStyle: {
        "line-height": "36px",
        "float": "right"
      }
    }, [_vm._v("\n          " + _vm._s(item.opetime) + "\n        ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "line-height": "36px",
        "float": "right",
        "margin-right": "16px"
      }
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.userType == 0 && index == 0),
        expression: "userType == 0 && index == 0"
      }],
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.editVer(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      staticStyle: {
        "color": "rgb(72,87,106)"
      }
    })])], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "line-height": "36px",
        "float": "right",
        "margin-right": "16px"
      }
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.userType == 0),
        expression: "userType == 0"
      }],
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.delVer(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "color": "rgb(72,87,106)"
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "markdownBody"
      },
      domProps: {
        "innerHTML": _vm._s(item.memo)
      }
    })])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-626bccab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bulletin/vlist.vue
// module id = 1060
// module chunks = 0